module.exports = "/_next/static/images/os_linux_arm64-46c0abb5b0d3c3b07be61ba441a627bf.svg";